/*
 * This function accepts a string of original standard color, a string of the color
 * the original should be replaced with if `loggedInAsUser` is true, and the
 * `loggedInAsUser` boolean prop as an object.
 */
export const mutateColorWhenLoggedInAsUser = (originalColor, mutatedColor, { loggedInAsUser }) =>
    loggedInAsUser ? mutatedColor : originalColor
